<!-- 移动端发送信息栏 -->
<template>
  <div class="input-content">
    <div v-if="clickItem.type === 1 && (questNum>0 || questNum===-1) && !closedChat && surplusTime && otherSys === 'applet'" class="times-tip">
        - <span v-if="groupOutTime > 0">本次问诊{{surplusTime}}后结束</span><span v-if="allQuestNum >0 &&questNum>-1">,<span v-if="userType === 1">患者</span>还剩<strong style="font-size:18px;color:#000">{{questNum}}</strong>次提问</span> -
    </div>
    <div class="times-tip" v-else-if="userType === 0 && otherSys === 'applet'">- 本次问诊已结束 -</div>
    <div class="times-tip" v-else-if="userType === 1 && otherSys === 'applet' && !surplusTime">- 患者已无问诊时间，会话关闭 -</div>
    <div class="times-tip" v-else-if="userType === 1 && otherSys === 'applet' && questNum==0">- 患者已无问诊次数，会话关闭 -</div>
    <!--患者才有提问次数和时间-->
    <div class="quick-content" v-if="otherSys === 'applet'">
        <!-- <el-scrollbar class="scrollbar"> -->
            <div class="quick-bar">
                <!-- <div class="quick-button" @click="offlineClick" v-if="userType === 1">
                    <i class="fa fa-edit green-icon"></i>
                    <span>线下医嘱</span>
                </div> -->
                <div class="quick-button" @click="patRecordClick">
                    <i class="iconfont icon-binli blue-icon"></i>
                    <span>患者病历</span>
                </div>
                <div class="quick-button" @click="yunCloud" v-if="userType === 1">
                    <i class="iconfont icon-kaidan-black yellow-icon"></i>
                    <span>云影像</span>
                </div>
                <div class="quick-button" @click="quickReply" v-if="userType === 1">
                    <i class="el-icon-s-open purple-icon"></i>
                    <span>快捷回复</span>
                </div>
                <!-- <div class="quick-button" @click="makeBill" v-if="userType === 1">
                    <i class="el-icon-s-open purple-icon"></i>
                    <span>移动开单</span>
                </div>
                <div class="quick-button" @click="prescribe" v-if="userType === 1">
                    <i class="el-icon-s-claim yellow-icon"></i>
                    <span>移动开药</span>
                </div> -->
                <!-- <div class="quick-button" @click="getScheduling">
                    <i class="iconfont icon-paiban red-icon"></i>
                    <span>临时排班</span>
                </div> -->
                <!-- <div class="quick-button" @click="finishChat" v-if="userType === 1 && (!closedChat && clickItem.groupStatus !== 2)">
                    <i class="iconfont icon-paiban red-icon"></i>
                    <span>结束会话</span>
                </div> -->
                <div class="quick-button" @click="restartChat" v-if="userType === 1 && (closedChat || clickItem.groupStatus === 2)">
                    <i class="iconfont icon-paiban red-icon"></i>
                    <span>重启会话</span>
                </div>
                <div class="quick-button" @click="typeInClick" v-if="userType === 1">
                    <i class="iconfont icon-luru purple-icon"></i>
                    <span>邀请医生</span>
                </div>
            </div>
        <!-- </el-scrollbar> -->
    </div>
    <div class="contain">
        <div class="content">
            <i class="iconfont icon-yuyinliaotian" @click="voiceShowClick"></i>
            <div @click="inputClick" @input="handlerInput" @propertychange="handlerInput" @focus="inputClick" @paste="pasteInput" id="input-main" contenteditable="true"></div>
            <i class="iconfont icon-yidongduantouxiang" @click="emojiShowClick"></i>
            <i v-if="!showSendButton" class="iconfont icon-yidongduangengduogongneng" @click="moreBarShowClick"></i>
            <el-button v-else class="sendButton" size="small" type="success" @click="sendMsg">发 送</el-button>
        </div>
        <div class="tool-bar" v-if="showMoreBar">
                <div class="one-box" @click="pictureClick">
                    <div class="button iconfont icon-picture"></div>
                    <span>照片</span>
                </div>
               <!--  <div class="one-box" @click="getCameraImg">
                    <div class="button iconfont icon-shexiangtou"></div>
                    <span>拍摄</span>
                </div> -->
                <div class="one-box" @click="voiceShowClick">
                    <div class="button iconfont icon-luyin"></div>
                    <span>语音</span>
                </div>
                <div class="one-box" @click="sendVideoClick">
                    <div class="button iconfont icon-shipinliaotian"></div>
                    <span>视频通话</span>
                </div>
                <!-- <div class="one-box" @click="offlineClick" v-if="otherSys === 'applet' && userType === 1">
                    <div class="button fa fa-edit"></div>
                    <span>线下医嘱</span>
                </div> -->
                <div class="one-box" @click="patRecordClick" v-if="otherSys === 'applet'">
                    <div class="button iconfont icon-binli"></div>
                    <span>患者病历</span>
                </div>
                <div class="one-box" @click="yunCloud" v-if="otherSys === 'applet' && userType === 1">
                    <div class="button iconfont icon-kaidan-black"></div>
                    <span>云影像</span>
                </div>
                <div class="one-box" @click="quickReply" v-if="otherSys === 'applet' && userType === 1">
                    <div class="button iconfont el-icon-s-open"></div>
                    <span>快捷回复</span>
                </div>
                <!-- <div class="one-box" @click="makeBill">
                    <div class="button iconfont el-icon-s-open"></div>
                    <span>移动开单</span>
                </div>
                <div class="one-box" @click="prescribe">
                    <div class="button iconfont el-icon-s-claim"></div>
                    <span>移动开药</span>
                </div> -->
                <!-- <div class="one-box" @click="getScheduling">
                    <div class="button iconfont icon-paiban"></div>
                    <span>临时排班</span>
                </div> -->
                <div class="one-box" @click="finishChat" v-if="otherSys === 'applet' && userType === 1 && (!closedChat && clickItem.groupStatus !== 2)">
                    <div class="button iconfont icon-paiban"></div>
                    <span>结束会话</span>
                </div>
                <div class="one-box" @click="restartChat" v-else-if="otherSys === 'applet' && userType === 1 && (closedChat || clickItem.groupStatus === 2)">
                    <div class="button iconfont icon-paiban"></div>
                    <span>重启会话</span>
                </div>
                <div class="one-box" @click="typeInClick" v-if="otherSys === 'applet' && userType === 1">
                    <div class="button iconfont icon-luru"></div>
                    <span>邀请医生</span>
                </div>
                <div class="one-box" @click="groupSetting" v-if="otherSys === 'applet'">
                    <div class="button fa fa-group"></div>
                    <span>群管理</span>
                </div>
                <div class="one-box" @click="getQuestionList" v-if="otherSys === 'applet' && userType === 1">
                    <div class="button fa el-icon-document"></div>
                    <span>问卷</span>
                </div>
        </div>
        <div class="emoji-bar" v-if="showEmoji">
            <span v-for="(item,key) in emojis" :key="key" @click="setEmoji(item.char)">{{item.char}}</span>
        </div>
        <div class="voice-block" v-if="showVoice" @mouseup.stop="mouseup">
            <div class="voice-block-main">
                <div v-if="startVoice" class="recording-block">
                    <div class="ft-l voice-small-bars">
                        <div class="hr10"></div>
                        <div class="hr9"></div>
                        <div class="hr8"></div>
                        <div class="hr7"></div>
                        <div class="hr6"></div>
                        <div class="hr5"></div>
                        <div class="hr4"></div>
                        <div class="hr3"></div>
                        <div class="hr2"></div>
                        <div class="hr1"></div>
                    </div>
                    <span>{{recordFormatTime}}</span>
                    <div class="ft-r voice-small-bars">
                        <div class="hr1"></div>
                        <div class="hr2"></div>
                        <div class="hr3"></div>
                        <div class="hr4"></div>
                        <div class="hr5"></div>
                        <div class="hr6"></div>
                        <div class="hr7"></div>
                        <div class="hr8"></div>
                        <div class="hr9"></div>
                        <div class="hr10"></div>
                    </div>
                </div>
                <div :class="['voice-button',startVoice ? 'start-voice':'']" unselectable="on" @mouseup.stop="mouseup" @mousedown.stop="mousedown" @touchstart.stop="touchstart" @touchmove.stop="touchmove" @touchend.stop="touchend" @touchcancel.stop="touchend">
                    <img aria-selected="false" class="unselectable" draggable="false" src="../../assets/record.png"/>
                </div>
                <span v-if="!startVoice" aria-selected="false" class="unselectable" draggable="false">请按住说话</span>
                <span  v-else aria-selected="false" class="unselectable" draggable="false">正在语音输入...</span>
                <div :class="!deleteFlag ? 'delete-button':'delete-button-red'" @mouseup.stop="deleteUp">
                    <div class="delete-img"></div>
                </div>
            </div>
        </div>
    </div>
    <!-- <video id="video"></video> -->
    <el-dialog
        title="患者病历"
        :visible.sync="patRecordVisible"
        width="80%"
        class="patRecord-dialog"
       >
        <div class="dialog-choose-button" @click="menzhenClick">
            <span>门诊病历</span>
        </div>
        <div class="dialog-choose-button" @click="zhuyuanClick">
            <span>住院病历</span>
        </div>
        <div class="dialog-choose-button" @click="jianchaClick">
            <span>检查检验</span>
        </div>
        <div class="dialog-choose-button" @click="yunCloud">
            <span>云影像</span>
        </div>
    </el-dialog>
    <el-dialog
        :visible.sync="groupSetVisible"
        width="90%"
        top="5vh"
        class="group-dialog"
    >
    <setting title="群管理" :clickItem="clickItem" :myUserId="myUserId" :userType="userType" :otherSys="otherSys" :settingShow="groupSetVisible" @addPeopleGroup="addPeopleGroup"></setting>
    </el-dialog>
    <presribeDialog
        :visible.sync="presribeVisible"
        :myUserId="myUserId"
        :patInfo="patInfo"
    ></presribeDialog>
    <el-dialog
        :visible.sync="applyVisible"
        width="80%"
        class="address-dialog"
    >
    <strong style="font-size:18px">如需开药，请提醒患者填写收药地址</strong>
    <span slot="footer" class="dialog-footer">
        <el-button style="float:left" type="success" size="medium" @click="remindAddress">提醒患者填写</el-button>
        <el-button type="primary" size="medium" @click="apply2Hospital">提交申请单</el-button>
    </span>
    </el-dialog>
    <quickReply v-if="replyShow" :replyShow.sync="replyShow" :myUserId="myUserId" @chooseText="chooseText"></quickReply>
    <el-dialog
        title="问卷列表"
        :visible.sync="questVisible"
        width="80%"
        class="address-dialog"
        :before-close="handleClose"
    >
    <el-table ref="questTable" :data="questionList" height="340px" @row-click="handleRowClick" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="45"></el-table-column>
      <el-table-column prop="name" label="名称" width="100"></el-table-column>
      <el-table-column prop="description" label="问卷描述" width="120" show-overflow-tooltip></el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="sendQuest">发送问卷</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
import emojis from '../../assets/emojis.json'
import {getAccountBalanceByPatId, apply2YunInHospital, getFormList4Chat} from '../../api/appletApi.js'
import {closeGroup, reStartGroup} from '../../api/api.js'
// import wx from 'weixin-js-sdk'
import setting from './setting.vue'
import presribeDialog from './presribeDialog.vue'
import quickReply from './quickReply.vue'
export default {
  name: '',
  mixins: [],
  components: {setting, presribeDialog, quickReply},
  props: {
    clickItem: {
      Object,
      default: () => {}
    },
    questNum: {// 剩余提问次数
      Number,
      default: 0
    },
    userType: {
      Number,
      default: 0
    },
    recordTime: {// 录制时长
      Number,
      default: 0
    },
    patInfo: {
      Object,
      default: () => {}
    },
    closedChat: {
      Boolean,
      default: false
    },
    askId: {
      String,
      default: ''
    },
    myUserId: {
      String,
      default: ''
    },
    otherSys: {
      String,
      default: ''
    },
    groupOutTime: {// 会话过期时长
      String,
      default: null
    },
    groupCreateTime: {// 会话创建时间
      String,
      default: null
    },
    allQuestNum: { // 提问总次数
      Number,
      default: 0
    }
  },
  data () {
    return {
      showMoreBar: false,
      showEmoji: false,
      showVoice: false,
      emojis: emojis,
      downTime: 0,
      startVoice: false,
      lock: true,
      showSendButton: false,
      patRecordVisible: false,
      deleteFlag: false,
      groupSetVisible: false,
      applyVisible: false,
      presribeVisible: false, // 开药弹窗visible
      replyShow: false, // 快捷回复页面
      surplusTime: '', // 剩余时间
      questionList: [],
      selectData: [],
      questVisible: false
    }
  },
  watch: {
    groupCreateTime: {
      handler (val) {
        if (this.sTime) clearInterval(this.sTime)
        if (val) {
          this.setSurplusTime()
          this.sTime = setInterval(() => {
            this.setSurplusTime()
          }, 1000)
        }
      },
      immediate: true
    },
    questNum: {
      handler (val) {
        if (this.userType === 0 && this.clickItem.type === 1 && val < 3 && val > 0) {
          this.$message.warning(`请注意，您还有${val}次提问机会`)
        }
      }
    }
  },
  computed: {
    recordFormatTime () {
      let val = this.recordTime
      let mintue = Math.trunc(val / 60)
      let second = val % 60
      if (second < 10) {
        second = '0' + second
      }
      return mintue + ':' + second
    }
  },
  created () {
  },
  mounted () {},
  beforeDestroy () {
    if (this.sTime) clearInterval(this.sTime)
  },
  methods: {
    setSurplusTime () {
      if (this.groupOutTime) { // 有会话时长规定
        if (this.groupCreateTime) {
          let time = this.$dayjs().diff(this.$dayjs(this.groupCreateTime))// 差异毫秒数
          let outTime = Number(this.groupOutTime) * 60 * 1000
          if (time > outTime) {
            this.surplusTime = ''
            // this.$emit('update:closedChat', true)
            this.$parent.$parent.closedChat = true
          } else {
            let stime = outTime - time
            stime = stime + 60 * 1000
            let day = Math.floor(stime / (1000 * 60 * 60 * 24)) // 天数
            stime = stime % (1000 * 60 * 60 * 24)// 剩余时间
            let hour = Math.floor(stime / (1000 * 60 * 60))// 小时
            stime = stime % (1000 * 60 * 60)// 剩余小时
            let minute = Math.floor(stime / (1000 * 60)) // 分钟
            // let second = Math.floor(stime % (1000 * 60) / 1000)// 剩余秒数
            this.surplusTime = `${day}天${hour}小时${minute}分钟`
          }
        } else {
          this.surplusTime = ''
        }
      }
    },
    // 向聊天框填入表情
    setEmoji (char) {
      document.getElementById('input-main').innerHTML += char
      this.handlerInput()
    },
    mousedown (event) { // 鼠标按下
    //   event.preventDefault()
      if ((this.closedChat || this.clickItem.groupStatus === 2) && this.userType === 0) {
        this.$message.error('会话已结束')
        return
      }
      this.downTime = setTimeout(() => {
        console.log('长按事件')
        this.lock = false
        this.startVoice = true
        this.$emit('startVoice')// 开始录音
      }, 1000)
    },
    mouseup (event) { // 鼠标抬起--发送语音
      if ((this.closedChat || this.clickItem.groupStatus === 2) && this.userType === 0) {
        return
      }
      clearTimeout(this.downTime)
      // 鼠标释放时让lock异步执行，setTimeout因为异步任务，所以会放到任务队列最后执行，让click事件先执行了
      setTimeout(() => {
        this.lock = true
      })
      if (!this.lock) {
        this.startVoice = false
        console.log('长按事件鼠标抬起...')
        this.$emit('sendVoice')
      }
    },
    touchstart (e) {
      this.mousedown()
    },
    touchmove (e) { // 计算移动距离，判断是否移动到删除按钮上了
      let dom = e.changedTouches[0]
      let clientX = dom.clientX
      let clientY = dom.clientY
      const WIDTH = window.innerWidth// 屏幕宽度
      const HEIGHT = window.innerHeight// 屏幕高度
      let leftx = WIDTH - (WIDTH / 2 - 80) // 删除按钮的左边界
      let rightx = WIDTH - (WIDTH / 2 - 80 - 66) // 删除按钮的右边界
      let topy = HEIGHT - 210 // 删除按钮顶部高度
      let bottomy = HEIGHT - 134 // 删除按钮底部高度
      if (clientX > leftx && clientX < rightx && clientY > topy && clientY < bottomy) {
        this.deleteFlag = true
      } else {
        this.deleteFlag = false
      }
    },
    touchend (e) {
      e.preventDefault()
      if (this.deleteFlag) { // 取消语音
        this.deleteUp()
        this.deleteFlag = false
      } else { // 发送语音
        this.mouseup()
      }
    },
    voiceClick (event) {
      event.preventDefault()
      if (this.lock) {
        console.log('单击事件')
      }
    },
    deleteUp (event) { // 删除鼠标抬起
      console.log('删除语音...')
      if (this.startVoice) { // 在录音时抬起
        this.startVoice = false
        this.$emit('cancelVoice')
      }
      // 鼠标释放时让lock异步执行，setTimeout因为异步任务，所以会放到任务队列最后执行，让click事件先执行了
      setTimeout(() => {
        this.lock = true
      })
    },
    inputClick () {
      this.showVoice = false
      this.showEmoji = false
      this.showMoreBar = false
      if (this.userType === 0 && this.clickItem.type === 1 && (this.questNum <= 0 || this.closedChat || !this.surplusTime) && this.otherSys === 'applet') { // 如果房间状态为关闭状态点击时候就提示不可发送
        this.$message.error('提问次数或时间超过限制')
      }
    },
    handleBlur () {
      setTimeout(() => {
        this.showSendButton = false // 失去光标就隐藏发送按钮
      }, 100)
    },
    pasteInput () {
      this.showSendButton = true
    },
    handlerInput () { // 输入框输入内容
      let val = document.getElementById('input-main').innerHTML
      if (val && val !== '<br>') { // 排除掉换行符
        this.showSendButton = true
      } else {
        this.showSendButton = false
      }
    },
    voiceShowClick () {
      this.showVoice = !this.showVoice
      this.showEmoji = false
      this.showMoreBar = false
    },
    emojiShowClick () {
      this.showEmoji = !this.showEmoji
      this.showMoreBar = false
      this.showVoice = false
    },
    moreBarShowClick () {
      this.showMoreBar = !this.showMoreBar
      this.showEmoji = false
      this.showVoice = false
    },
    sendVideoClick () { // 发起视频
      if (this.userType === 0) { // 患者无通话权限
        this.$message.error('无通话权限')
        return
      }
      /* if ((this.closedChat || this.clickItem.groupStatus === 2) && this.userType === 0) {
        this.$message.error('会话已结束')
        return
      } */
      /* if (this.patInfo.askType !== 2 && this.patInfo.consultType !== 6) { // 视频
        this.$message.error('无通话权限')
        return
      } */
      this.$emit('goInVideo')
    },
    pictureClick () {
      // 图片click
      if ((this.closedChat || this.clickItem.groupStatus === 2) && this.userType === 0) {
        this.$message.error('会话已结束')
        return
      }
      this.$emit('pictureClick')
    },
    sendMsg () { // 发送信息
      if ((this.closedChat || this.clickItem.groupStatus === 2) && this.userType === 0) {
        this.$message.error('会话已结束')
        return
      }
      this.$emit('sendMsg')
      this.showSendButton = false
    },
    patRecordClick () { // 患者病历点击
      if ((this.closedChat || this.clickItem.groupStatus === 2) && this.userType === 0) {
        this.$message.error('会话已结束')
        return
      }
      if (!this.askId || !this.patInfo.patId) {
        this.$message.error('无患者病历')
        return
      }

      this.patRecordVisible = true
    },
    menzhenClick () { // 跳转小程序门诊病历
      // eslint-disable-next-line no-undef
      if ((this.closedChat || this.clickItem.groupStatus === 2) && this.userType === 0) {
        this.$message.error('会话已结束')
        return
      }
      this.patRecordVisible = false
      //   this.$router.push({path: '/consultation', query: {patId: this.patInfo.patId}})
      wx.miniProgram.navigateTo({url: `/pagesB/pages/consultations/consultations?from=chat&patName=${this.patInfo.patName}&patId=${this.patInfo.patId}`})
    },
    zhuyuanClick () { // 跳转小程序住院病历
      // eslint-disable-next-line no-undef
      if ((this.closedChat || this.clickItem.groupStatus === 2) && this.userType === 0) {
        this.$message.error('会话已结束')
        return
      }
      this.patRecordVisible = false
      //   this.patInfo.patId = '000000000000189'
      //   this.$router.push({path: '/inHospital', query: {patId: this.patInfo.patId}})
      wx.miniProgram.navigateTo({url: `/pagesB/pages/inHospital/inHospital?from=chat&patName=${this.patInfo.patName}&patId=${this.patInfo.patId}`})
    },
    jianchaClick () {
      // eslint-disable-next-line no-undef
      if ((this.closedChat || this.clickItem.groupStatus === 2) && this.userType === 0) {
        this.$message.error('会话已结束')
        return
      }
      //   this.$message.warning('正在开发中...')
      this.patRecordVisible = false
      //   this.patInfo.patId = '000000000000189'
      //   this.$router.push({path: '/report', query: {patId: this.patInfo.patId}})
      wx.miniProgram.navigateTo({url: `/pagesB/pages/report/report?from=chat&patName=${this.patInfo.patName}&patId=${this.patInfo.patId}`})
    },
    yunCloud () {
      if ((this.closedChat || this.clickItem.groupStatus === 2) && this.userType === 0) {
        this.$message.error('会话已结束')
        return
      }
      //   getImageCloudUrl({patId: this.patInfo.patId}).then(data => {
      //     // window.location.href = data
      //     this.$router.push({path: '/image', query: {url: data}})
      //   })
      this.patRecordVisible = false
      wx.miniProgram.navigateTo({url: `/pagesB/pages/report/yunReport?from=chat&patId=${this.patInfo.patId}`})
      /*  this.patRecordVisible = false
      console.log('this.patInfo', this.patInfo)
      this.$router.push({path: '/image', query: {mpi: this.patInfo.mpi, patientName: this.patInfo.patientName}}) */
    },
    quickReply () { // 快捷回复
      this.replyShow = true
    },
    getCameraImg () { // 获取摄像头拍摄
      if ((this.closedChat || this.clickItem.groupStatus === 2) && this.userType === 0) {
        this.$message.error('会话已结束')
        return
      }
      this.$emit('cameraClick')
    },
    offlineClick () { // 线下医嘱
      let patId = this.patInfo.patId
      getAccountBalanceByPatId({patId}).then(data => {
        if (data) {
        //   let money = Number(data.accountBalance)
          //   if (money >= 12) {
          this.applyVisible = true
        //   } else {
        //     this.$message.error('预存余额小于12元')
        //   }
        }
      })
    },
    apply2Hospital () { // 向院内提交开单申请
      let params = {
        userId: this.myUserId,
        patId: this.patInfo.patId
      }
      apply2YunInHospital(params).then(data => {
        if (data) {
          this.$message.success('已向院内提交申请，请到院内PC端操作')
          this.applyVisible = false
        }
      })
    },
    getScheduling () { // 临时排班
      this.$message.error('该功能暂未开放')
    },
    typeInClick () { // 病历录入
    //   this.$message.error('该功能暂未开放')
      wx.miniProgram.navigateTo({url: `/pagesA/index/index?defaultTab=2&from=chatroom&groupId=${this.clickItem.id}`})
    },
    remindAddress () { // 发送确认收货的功能应用消息
      let params = {
        type: 1,
        content: '请确认收货地址'
      }
      this.$emit('sendMsg', 'apply', params)
      this.$message.success('已发送确认收货消息')
    },
    finishChat () { // 结束会话
      if ((this.closedChat || this.clickItem.groupStatus === 2) && this.userType === 0) {
        this.$message.error('会话已结束')
        return
      }
      this.$confirm('此操作将关闭会话, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          groupId: this.clickItem.id,
          userId: this.myUserId
        }
        closeGroup(params).then(data => {
          if (this.userType === 0) { // 患者才关闭页面的closeChat状态
            this.$emit('update:closedChat', true)
          }
        //   overConsult({id: this.clickItem.id})
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    restartChat () { // 重启会话
      this.$confirm('此操作将重启会话, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          groupId: this.clickItem.id,
          userId: this.myUserId
        }
        reStartGroup(params).then(data => {
        //   this.$emit('update:closedChat', false)
          this.$parent.$parent.closedChat = false
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    groupSetting () { // 查看群管理信息
    //   this.$parent.$parent.settingClick()
      this.groupSetVisible = true
    },
    addPeopleGroup (val) {
      this.$parent.$parent.addPeopleGroup(val)
    },
    chooseText (val) { // 选择快捷回复
      document.getElementById('input-main').innerHTML = val
      this.showSendButton = true
    //   this.$emit('sendMsg')
    //   document.getElementById('input-main').innerHTML = ''
    },
    getQuestionList () { // 获取问卷列表
      this.questVisible = true
      getFormList4Chat({userId: this.myUserId}).then(data => {
        this.questionList = data
      })
    },
    sendQuest () { // 发送问卷
      this.selectData.forEach(el => {
        el.msgType = 4
        this.$emit('sendMsg', 'apply', el)
        this.handleClose()
      })
    },
    handleSelectionChange (val) {
      this.selectData = val
    },
    handleClose () {
      this.$refs.questTable.clearSelection()
      this.selectData = []
      this.questVisible = false
    },
    handleRowClick (row) {
      let i = this.selectData.findIndex(v => {
        return row === v
      })
      if (i > -1) {
        this.$refs.questTable.toggleRowSelection(row, false)
      } else {
        this.$refs.questTable.toggleRowSelection(row, true)
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.input-content{
    min-height: 82px;
    width: 100%;
    background: #fff;
    height: auto;
    flex-shrink: 0;
    .tool-disabled{
        color:#bfbfbf;
        pointer-events: none;
        cursor: none;
    }
    .tool-active{
        pointer-events: auto;
    }
    .times-tip{
        width: 100%;
        height: 20px;
        text-align: center;
        padding-bottom: 10px;
        background: #EEEFF2;
        padding-top: 10px;
        color: #919398;
    }
    .quick-content{
        width: 100%;
        position: relative;
        height: 40px;
        overflow: hidden;
        .quick-bar{
            width: 100%;
            height:40px;
            padding: 8px 6px 2px 6px;
            background: #F5F6F8;
            box-sizing: border-box;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            overflow-x: auto;
            overflow-y: hidden;
            display: flex;
            .quick-button{
                width:96px;
                height: 30px;
                line-height: 30px;
                border-radius: 15px;
                background: #fff;
                text-align: center;
                margin: 0 6px;
                flex-shrink: 0;
                cursor: pointer;
                .blue-icon{
                    color:#38C6EA;
                }
                .yellow-icon{
                    color:#FFC001;
                }
                .red-icon{
                    color:#FF6245;
                }
                .purple-icon{
                    color:#9998F4
                }
                .green-icon{
                    color: #25cd76;
                }
            }
        }
        /deep/ .is-horizontal {
            display: none;
        }
    }
    .contain{
        margin-bottom:20px;
        .content{
            background: #F5F6F8;
            padding: 6px 10px;
            width: 100%;
            min-height: 48px;
            height: auto;
            box-sizing: border-box;
            display: flex;
            align-items: flex-end;
            .iconfont{
                font-size: 28px;
                margin-right: 10px;
                cursor: pointer;
            }
            #input-main{
                width: calc(100% - 124px);
                min-height: 36px;
                max-height: 130px;
                background: #fff;
                border: none;
                resize: none;
                outline: none;
                padding: 5px 15px;
                overflow: auto;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                word-break: break-all;
                margin-right: 10px;
                padding-top: 7px;
            }
            .sendButton{
                margin-bottom: 3px;
                border-radius: 8px;
                background-color: #07C160;
                border-color: #07C160;
                padding: 8px 15px;
                font-size: 14px;
                span{
                    font-size: 14px;
                }
            }
        }
        .tool-bar{
            padding:12px 24px;
            background: #F5F6F8;
            .one-box{
                text-align: center;
                width: 60px;
                height: auto;
                display: inline-block;
                margin: 5px 10px;
                .button{
                    border-radius: 4px;
                    text-align: center;
                    line-height: 52px;
                    width: 52px;
                    height: 52px;
                    background: #fff;
                    margin-bottom:4px;
                }
                .iconfont,.fa{
                    display: block;
                    font-size: 28px;
                    cursor: pointer;
                    margin: auto;
                    margin-bottom: 4px;
                }
            }
            .one-line{
                display: flex;
                justify-content: space-between;
                &:first-child{
                    margin-bottom: 13px;
                }
            }
        }
        .emoji-bar{
            padding: 12px 18px;
            background: #F5F6F8;
            max-height: 147px;
            overflow: auto;
            // width: 100%;
            // box-sizing: border-box;
            span{
                font-size: 27px;
                display: inline-block;
            }
        }
        .voice-block{
            width: 100%;
            height: 240px;
            background:#F5F6F8;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            .voice-block-main{
                // width: 164px;
                // height: 164px;
                text-align: center;
                position:relative;
                .recording-block{
                    margin-bottom: 16px;
                    position: absolute;
                    top: 0px;
                    left:-30px;
                    width: 164px;
                }
                .delete-button{
                    background: #F2F3F5;
                    width:56px;
                    height: 56px;
                    border-radius: 28px;
                    position: absolute;
                    top: 40px;
                    right: -100px;
                    cursor: pointer;
                    .delete-img{
                        width: 23px;
                        height: 23px;
                        background: url('../../assets/delete-gray.png');
                        margin-top: 16px;
                        margin-left: 16px;
                    }
                    &:hover{
                        background: #FFECE8;
                        .delete-img{
                            background: url('../../assets/delete-red.png');
                        }
                    }
                }
                .delete-button-red{
                    background: #FFECE8;
                    width:56px;
                    height: 56px;
                    border-radius: 28px;
                    position: absolute;
                    top: 40px;
                    right: -100px;
                    cursor: pointer;
                    .delete-img{
                        width: 23px;
                        height: 23px;
                        background: url('../../assets/delete-red.png');
                        margin-top: 16px;
                        margin-left: 16px;
                    }
                }

            }
            .voice-button{
                width: 100px;
                height: 100px;
                border-radius: 50px;
                text-align: center;
                background-color: #fff;
                box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
                cursor:pointer;
                margin-bottom: 24px;
                margin-top: 36px;

                -moz-user-select: none;
                -khtml-user-select: none;
                user-select: none;
                -webkit-tap-highlight-color: rgba(255,0,0,0);

                img{
                    margin-top: 18px;
                    pointer-events: none;
                }
            }
            .unselectable{
                -moz-user-select: -moz-none;
                -khtml-user-select: none;
                -webkit-user-select: none;
                -o-user-select: none;
                user-select: none;
            }
            .start-voice{
                background-color: #F2F3F5;
                box-shadow: inset 0px 0px 8px rgba(0, 0, 0, 0.05);
            }
            span{
                color: #919398;
                margin-top: 24px;
            }
            .voice-small-bars{
                div{
                    width:2px;
                    height: 16px;
                    background: #C9CDD4;
                    display: inline-block;

                    animation: note 3s ease-in-out;
                    animation-iteration-count: infinite;
                    animation-direction: alternate;
                }
                .hr1 {
                    animation-delay: -3s;
                }

                .hr2 {
                    animation-delay: -2.6s;
                }

                .hr3 {
                    animation-delay: -2.3s;
                }

                .hr4 {
                    animation-delay: -2.0s;
                }

                .hr5 {
                    animation-delay: -1.6s;
                }

                .hr6 {
                    animation-delay: -1.3s;
                }

                .hr7 {
                    animation-delay: -1.0s;
                }

                .hr8 {
                    animation-delay: -0.6s;
                }

                .hr9 {
                    animation-delay: -0.3s;
                }

                .hr10 {
                    animation-delay: -0s;
                }

                @keyframes note {
                    from {
                        background: #C9CDD4;
                    }
                    to {
                        background: #0DB4AA;
                    }
                }
            }
        }
    }
    .ft-l{
        float:left;
    }
    .ft-r{
        float: right;
    }
}
.patRecord-dialog{
    /deep/ .el-dialog{
        border-radius: 8px;
    }
}
.address-dialog{
    /deep/ .el-dialog{
        border-radius: 8px;
        max-width: 400px;
    }
}
.group-dialog{
   /deep/ .el-dialog{
        height: calc(100% - 12vh);
        .el-dialog__header{
            padding:20px;
            padding-bottom:20px;
        }
        .el-dialog__body{
            height: 100%;
            padding: 0px 0px;
            #back-to-main{
                display: none !important;
            }
            .history-title{
                display: none;
            }
        }
    }
}
.el-dialog{
    .el-dialog__body{
            padding: 10px 20px;
        .dialog-choose-button{
            width: 100px;
            border: 1px solid #0db4aa;
            border-radius: 20px;
            padding: 8px 16px;
            margin: auto;
            margin-bottom: 15px;
            cursor: pointer;
            text-align: center;
            color:#0db4aa;
        }
    }
}
</style>
<style lang="scss">
.quick-content{
    ::-webkit-scrollbar{
        display: none!important;
    }
    ::-webkit-scrollbar-track {
        display: none!important;
    }
    /* 滚动条滑块 */
    ::-webkit-scrollbar-thumb {
        display: none!important;
    }
}
</style>



// WEBPACK FOOTER //
// packages/chat/src/phone-input.vue